var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.624 3.776 4.2 3.353l-.847.847.423.424L11.153 12l-7.377 7.376-.423.424.847.848.424-.424L12 12.848l7.376 7.376.424.424.848-.848-.424-.424L12.848 12l7.376-7.376.424-.424-.848-.847-.424.423L12 11.153z"
  })));
};
export default SvgClose;